module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epit"
  }, [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Who looks at Lee must think of Washington;")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("In pain must think, and hide the thought,")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("So deep with grievous meaning it is fraught.")])]), _c('p', {
    staticClass: "epia"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("—Herman Melville, “Lee in the Capitol”")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0